import $ from 'jquery';

class Header {
    constructor() {
        this.header = $('.header');
        this.navIconBar = $('.mobile-menu');
        this.nav = $('.nav__list');
        this.body = $('body');
        this.navItem = $('.nav__item');
        this.events();
        this.isSticky();
    }

    events() {
        const _this = this;

        this.navIconBar.click(this.toggleNav.bind(this));

        //add icon to menu
        this.addIconarrowIcon();

        $(document).click((e) => {
            if ($(e.target).is('.nav__arrow')) {
                if (!_this.isActiveAccordion(e)) {
                    _this.closeAccordion(_this.navItem);
                    _this.openAccordion($(e.target).parent());
                } else {
                    _this.closeAccordion(_this.navItem);
                }
            }
        })
    }

    //toggle nav
    toggleNav() {
        this.body.toggleClass('navOpen');
        this.nav.slideToggle();
    }

    //added nav indicator icon
    addIconarrowIcon() {
        this.navItem.each(function (i, v) {
            const $this = $(this);
            if ($this.find('.dropdown').length) {
                $this.append(`<button class="nav__arrow"></button>`)
            }
        })
    }

    //open accordion
    openAccordion(item) {
        $(item).addClass('active').find('.dropdown').slideDown()
    }


    //close accordion
    closeAccordion(allItem) {
        $(allItem).removeClass('active').find('.dropdown').slideUp();
    }

    //isActive
    isActiveAccordion(el) {
        return $(el.target).parent().hasClass('active') ? true : false;
    }

    //check if you window getter than 1;
    isSticky() {
        $(window).on('scroll', () => {
            var windowPos = $(window).scrollTop();
            if( windowPos >= 1) {
                this.header.addClass('header--sticky');
            }else {
                this.header.removeClass('header--sticky');
            }
        })
    }

    showDropdown() {
        this.navItem.each( (i, el) => {

        });
    }

}

export default Header;